import { render, staticRenderFns } from "./modalTecnicas.vue?vue&type=template&id=6102194d&scoped=true"
import script from "./modalTecnicas.vue?vue&type=script&lang=js"
export * from "./modalTecnicas.vue?vue&type=script&lang=js"
import style0 from "./modalTecnicas.vue?vue&type=style&index=0&id=6102194d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6102194d",
  null
  
)

export default component.exports